// Actions
export const API_RESPONSE_SUCCESS = "API_RESPONSE_SUCCESS";
export const API_RESPONSE_ERROR = "API_RESPONSE_ERROR";
export const GET_SPECIALTIES = "GET_SPECIALTIES";
export const CREATE_SPECIALTIES = "CREATE_SPECIALTIES";
export const UPDATE_SPECIALTIES = "UPDATE_SPECIALTIES";
export const DELETE_SPECIALTIES = "DELETE_SPECIALTIES";
